import { render, staticRenderFns } from "./DomainDetail.vue?vue&type=template&id=332c85e6&"
import script from "./DomainDetail.vue?vue&type=script&lang=js&"
export * from "./DomainDetail.vue?vue&type=script&lang=js&"
import style0 from "./DomainDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports